import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CardConfig, MenuAction} from '@shared/model';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent {
  @Input() config?: CardConfig;
  @Input() extraTitleText = '';
  @Output() onActionClick = new EventEmitter<MenuAction>();
}
